import React, {useState} from 'react';
import {classes, style} from './doppe-action-type-widget-inner-description.st.css';
import {CommonClasses, FlexLayout} from '@wix/devzai-common-client';
import {ClampedText, Icon, RichTextContent, richTextContentIsNullableOrWhiteSpace} from '@wix/devzai-utils-react';
import IconChevronUp from '../doppe-action-button-templates/doppe-standard-action-button-template/icons/ChevronUp.svg';
import IconChevronDown
    from '../doppe-action-button-templates/doppe-standard-action-button-template/icons/ChevronDown.svg';
import {DoppeHideableValue, doppeHideableValueIsHidden} from '../../client-server-common/types/doppe-hideable-value';
import {
    DoppeActionContentTipTapExtensions,
    DoppeRichTextContentType
} from '../../client-server-common/doppe-tiptap-extensions/doppe-tiptap-extensions';
import {WidgetRenderingContextType} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    DoppeViewerRichTextView,
    DoppeViewerRichTextViewHtmlRenderingMode
} from "../doppe-viewer-rich-text-view/doppe-viewer-rich-text-view";
import {
    useAssertWidgetRenderingContextType
} from "../doppe-viewer-widget-rendering-context/doppe-viewer-widget-rendering-context";

export const DoppeActionTypeWidgetInnerDescription = React.memo(function DoppeActionTypeWidgetInnerDescription(props: DoppeActionTypeWidgetInnerDescription.Props) {
    const {
        children,
        maxLines,
        className,
        ...htmlAttributes
    } = props;

    const [shouldClamp, setShouldClamp] = useState(true);
    const [isClamped, setIsClamped] = useState(false);
    const widgetRenderingContextType = useAssertWidgetRenderingContextType();

    const calculatedMaxLines = (widgetRenderingContextType === WidgetRenderingContextType.Modal ? Infinity : maxLines ?? 4);


    if (doppeHideableValueIsHidden(children) || richTextContentIsNullableOrWhiteSpace(children, DoppeActionContentTipTapExtensions)) {
        return null;
    }


    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, className)}
        >
            <ClampedText
                className={style(classes.content, {})}
                maxLines={calculatedMaxLines}
                onIsClampedChanged={setIsClamped}
                clampText={shouldClamp}
            >
                {typeof children === 'string' ? children : (
                    <DoppeViewerRichTextView
                        richText={children}
                        richTextContentType={DoppeRichTextContentType.DoppeActionContent}
                        htmlRenderingMode={DoppeViewerRichTextViewHtmlRenderingMode.FullRichText}
                    />
                )}
            </ClampedText>
            {isClamped ? (
                <div
                    onClick={() => {
                        setShouldClamp(shouldClamp => !shouldClamp);
                    }}
                    className={style(classes.readMoreButton, {}, FlexLayout.row.alignToCenter, CommonClasses.button)}
                >
                    <div>{!shouldClamp ? 'Show less' : 'Show more'}</div>
                    <Icon
                        className={style(classes.chevronIcon, {})}
                        icon={!shouldClamp ? IconChevronUp : IconChevronDown}
                    />
                </div>
            ) : null}
        </div>
    );
});

export namespace DoppeActionTypeWidgetInnerDescription {

    export interface Props extends React.HTMLAttributes<any> {
        children: DoppeHideableValue<RichTextContent>;
        maxLines?: number;
    }
}

